/* HOA-KIT · Verhalten für alle Seiten (29.09.2026, Werkbank 13)
   - [data-hk-modal="id"]  öffnet <dialog id="id" class="hk-modal">; schließt per ×, ESC, Klick daneben
   - [data-hk-rein]        blendet beim Scrollen weich ein
   - .hk-karte             Licht folgt Maus/Finger
   - [data-hk-karussell]   Pfeile + Punkte für eine .hk-spur
   - [data-hk-kopie="TEXT"] kopiert Text, zeigt „Kopiert ✓"
   Einmal laden reicht; mehrfach eingebunden passiert nichts doppelt. */
(function(){
  if(window.__hoaKit) return; window.__hoaKit=1;
  var ruhig=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var html=document.documentElement;

  function oeffne(d,ausloeser){
    if(!d) return;
    d.__zurueck=ausloeser||document.activeElement;
    if(typeof d.showModal==='function'){ if(!d.open) d.showModal(); } else { d.setAttribute('open',''); }
    html.classList.add('hk-modal-offen');
    d.dispatchEvent(new CustomEvent('hk:auf',{bubbles:true}));
  }
  function schliesse(d){
    if(!d) return;
    if(typeof d.close==='function'&&d.open) d.close(); else d.removeAttribute('open');
  }
  window.hoaKit={oeffne:oeffne,schliesse:schliesse};

  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-hk-modal]');
    if(t){ e.preventDefault(); oeffne(document.getElementById(t.getAttribute('data-hk-modal')),t); return; }
    var z=e.target.closest('[data-hk-zu]');
    if(z){ e.preventDefault(); schliesse(z.closest('dialog')); return; }
    if(e.target.tagName==='DIALOG'&&e.target.classList.contains('hk-modal')){
      var r=e.target.getBoundingClientRect();
      if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) schliesse(e.target);
    }
    var k=e.target.closest('[data-hk-kopie]');
    if(k){
      e.preventDefault(); var txt=k.getAttribute('data-hk-kopie'), alt=k.innerHTML;
      var fertig=function(){ k.innerHTML='Kopiert ✓'; setTimeout(function(){ k.innerHTML=alt; },1800); };
      if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(txt).then(fertig,fertig); } else { fertig(); }
    }
  });
  document.addEventListener('close',function(e){
    if(e.target.tagName!=='DIALOG') return;
    if(!document.querySelector('dialog.hk-modal[open]')) html.classList.remove('hk-modal-offen');
    var z=e.target.__zurueck; if(z&&z.focus) try{ z.focus({preventScroll:true}); }catch(_){}
  },true);

  /* Einblenden */
  function rein(){
    var els=[].slice.call(document.querySelectorAll('[data-hk-rein]:not(.ist-da)'));
    if(ruhig||!('IntersectionObserver' in window)){ els.forEach(function(el){ el.classList.add('ist-da'); }); return; }
    var io=new IntersectionObserver(function(es){ var k=0; es.forEach(function(en){ if(en.isIntersecting){ en.target.style.transitionDelay=Math.min(k++,4)*70+'ms'; en.target.classList.add('ist-da'); io.unobserve(en.target); } }); },{rootMargin:'0px 0px -6% 0px',threshold:.05});
    els.forEach(function(el){ io.observe(el); });
  }

  /* Licht folgt der Maus */
  var raf=0,lk=null,lx=0,ly=0;
  document.addEventListener('pointermove',function(e){
    var k=e.target.closest&&e.target.closest('.hk-karte'); if(!k) return;
    lk=k; lx=e.clientX; ly=e.clientY;
    if(!raf) raf=requestAnimationFrame(function(){ raf=0; if(!lk) return; var r=lk.getBoundingClientRect();
      lk.style.setProperty('--mx',((lx-r.left)/r.width*100).toFixed(1)+'%'); lk.style.setProperty('--my',((ly-r.top)/r.height*100).toFixed(1)+'%'); });
  },{passive:true});

  /* Karussell */
  function karussells(){
    document.querySelectorAll('[data-hk-karussell]:not([data-hk-bereit])').forEach(function(w){
      w.setAttribute('data-hk-bereit','');
      var spur=w.querySelector('.hk-spur'); if(!spur) return;
      var li=w.querySelector('[data-hk-links]'), re=w.querySelector('[data-hk-rechts]'), pk=w.querySelector('.hk-punkte');
      var kids=[].slice.call(spur.children);
      function schritt(){ var c=kids[0]; return c?c.getBoundingClientRect().width+16:300; }
      if(li) li.addEventListener('click',function(){ spur.scrollBy({left:-schritt(),behavior:ruhig?'auto':'smooth'}); });
      if(re) re.addEventListener('click',function(){ spur.scrollBy({left:schritt(),behavior:ruhig?'auto':'smooth'}); });
      if(pk){ pk.innerHTML=''; kids.forEach(function(c,i){ var b=document.createElement('button'); b.type='button'; b.setAttribute('aria-label','Zu Karte '+(i+1));
        b.addEventListener('click',function(){ spur.scrollTo({left:c.offsetLeft-spur.offsetLeft-parseFloat(getComputedStyle(spur).paddingLeft||0),behavior:ruhig?'auto':'smooth'}); }); pk.appendChild(b); }); }
      function upd(){
        var max=spur.scrollWidth-spur.clientWidth-2;
        if(li) li.disabled=spur.scrollLeft<=2; if(re) re.disabled=spur.scrollLeft>=max;
        if(pk){ var idx=Math.round(spur.scrollLeft/schritt()); [].forEach.call(pk.children,function(b,i){ b.classList.toggle('ist-an',i===Math.min(idx,kids.length-1)); }); }
      }
      spur.addEventListener('scroll',function(){ requestAnimationFrame(upd); },{passive:true}); window.addEventListener('resize',upd); upd();
    });
  }

  function init(){ rein(); karussells(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
  window.hoaKit.init=init;
})();
